export default __webpack_public_path__ + "static/media/real-estate-1.7fd7203b.png";